/*eslint-disable */

import InterviewCourses from './interviewCourses';
import MediaDetails from './media';
import PublicQuiz from './publicQuiz';
import QuizBanner from './quizBanner';
import QuizContest from './quizContest';
import Vue from 'vue';
import Vuex from 'vuex';
import assignmentStore from './assignment';
import authVerifiedStore from './authVerifiedStore';
import authentication from './authenticate'
import interviewContestStore from './interviewContestStore';
import paypalPayment from './payment';
import profileStore from './profile';
import publicCourseStore from './publicCourseStore';
import userCourses from './userCourses';
import userNotes from './userNotes';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    authentication,
    userCourses,
    profileStore,
    publicCourseStore,
    assignmentStore,
    authVerifiedStore,
    paypalPayment,
    MediaDetails,
    userNotes,
    PublicQuiz,
    QuizContest,
    InterviewCourses,
    QuizBanner,
    interviewContestStore
  }
})
